export function renderInsightCard(text: string): HTMLElement {
  const card = document.createElement('div');
  card.className = 'card border border-blue-100 bg-blue-50';

  const label = document.createElement('div');
  label.className = 'text-xs uppercase tracking-wide text-blue-700 font-semibold mb-2';
  label.textContent = 'Insight';

  const body = document.createElement('p');
  body.className = 'text-gray-800 leading-relaxed';
  body.textContent = text;

  card.appendChild(label);
  card.appendChild(body);
  return card;
}
